module.exports = new __parcel__URL__("slack.26cbe450.svg").toString();